import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from './auth/auth.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterLink, CommonModule],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit, OnDestroy {
  protected readonly title = signal('delivery-ops');
  toggle: boolean = false;
  isLoggedIn = signal<boolean>(false);
  private role: string;
  loggedInObservable: Subscription;
  loadingObservable: Subscription;

  constructor(private authService: AuthService, private router: Router) { }

  login(){
    //this.authService.openLoginDialog();
    this.router.navigate(['/login']);
  }
  logout(){
    this.authService.logout();

  }



  async ngOnInit(): Promise<void> {

    const authResponse = await this.authService.checkAccountStatus();
    if (authResponse) {
      await this.authService.updateAuthState(authResponse);
    }

    this.loggedInObservable = this.authService.getAuthState().subscribe(async authResponse => {
      const auth = authResponse.guest != null && authResponse.guest === false;
      this.isLoggedIn.set(auth);
      if (authResponse) {
        this.role = authResponse.role;
      }

    });

  }

  async ngOnDestroy(): Promise<void> {
    this.loggedInObservable.unsubscribe();
    this.loadingObservable.unsubscribe();

  }

}
